import './index.css'

import React, { ReactElement, useEffect, useState } from 'react'

import { Button } from 'primereact/button'

import NavItems from './NavItems'

export default function Navigation(): ReactElement {
  const [sidebarClassName, setSidebarClassName] = useState('navClosed')
  //const [isMaskActive, setIsMaskActive] = useState(false)
  const [maskClassName, setMaskClassName] = useState('')

  function toggleSidebarClassName(): void {
    const newClassNameSidebar = sidebarClassName === 'navClosed' ? 'navOpen' : 'navClosed'
    const newClassNameMask = maskClassName === 'mask-active' ? '' : 'mask-active'

    setSidebarClassName(newClassNameSidebar)
    setMaskClassName(newClassNameMask)
  }

  useEffect(() => {
    /* If nav is open and you resize your window to smartphone view the nav closes so the black mask is not showing */
    function handleResize(): void {
      // console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      if (window.innerWidth <= 992) {
        setSidebarClassName('navClosed')
        setMaskClassName('')
      }
    }

    window.addEventListener('resize', handleResize)
  })

  return (
    <>
      <Button
        icon="pi pi-bars"
        className="button-sidebar p-button-text p-button-plain"
        onClick={toggleSidebarClassName}
      />
      <nav className={'main-nav ' + sidebarClassName}>
        <div className="menuTitle"></div>
        <NavItems setSidebarClassName={setSidebarClassName} setMaskClassName={setMaskClassName} />
      </nav>
      <div
        aria-hidden="true"
        role="button"
        className={'mask ' + maskClassName}
        onClick={toggleSidebarClassName}
      ></div>
    </>
  )
}
